// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yGsni8m6l115KUVeolhQ{width:170px}`, "",{"version":3,"sources":["webpack://./src/app/catalog/product/components/product-no-stock.component/style.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA","sourcesContent":[".product-no-stock-container {\n  width: 170px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product-no-stock-container": `yGsni8m6l115KUVeolhQ`
};
export default ___CSS_LOADER_EXPORT___;
